import { motion } from 'framer-motion';
import { Link } from 'gatsby';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

export const LoginHeader: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="auth__header">
      <motion.h1
        style={{
          opacity: 0,
          y: 8,
        }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.5, type: 'spring' }}
        className="auth__header--message t-bold t-text-1"
        data-cy="welcome-message"
      >
        <FormattedMessage id="login.title" />
      </motion.h1>
      <motion.p
        style={{
          opacity: 0,
          y: 8,
        }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.5, delay: 0.2, type: 'spring' }}
        className="text--xs__responsive t-text-1 auth__header__description"
      >
        <FormattedMessage id="login.description" />{' '}
        <Link
          to={formatMessage({ id: 'routes.register' })}
          data-cy="register-link"
          className="t-bold"
        >
          <FormattedMessage id="buttons.create-account" />
        </Link>
      </motion.p>
    </div>
  );
};
